import React, { useState } from "react";
import {
  Cell,
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableHeader,
} from "@vds/tables";

function BulkRuleTable({data}) {
  console.log(Array.isArray(data),"DATA",data)

  const headerStyle = {
    padding: "2rem 0rem 2rem 0rem",
  };



  return (
    <div>
      <Table striped={false} surface="light" padding="standard">
        <TableHead>
          <TableHeader style={{ ...headerStyle, width: "10%" }}>
            Name
          </TableHeader>
          <TableHeader style={{ ...headerStyle, width: "10%" }}>
            App
          </TableHeader>
          <TableHeader style={{ ...headerStyle, width: "10%" }}>
            Site
          </TableHeader>
          <TableHeader style={{ ...headerStyle, width: "10%" }}>
            Floor
          </TableHeader>
          <TableHeader style={{ ...headerStyle, width: "10%" }}>
            Area
          </TableHeader>
          <TableHeader style={{ ...headerStyle, width: "10%" }}>
            Camera
          </TableHeader>
          <TableHeader style={{ ...headerStyle, width: "15%" }}>
            Region of Interest
          </TableHeader>
          <TableHeader style={{ ...headerStyle, width: "15%" }}>
            Condition
          </TableHeader>
        </TableHead>
        <TableBody>
          {Array.isArray(data) && data?.map((item,index)=>(
          <TableRow key={index}>
          <Cell style={{ width: "20%" }}>{item.name}</Cell>
          <Cell style={{ width: "12%" }}>{item.app}</Cell>
          <Cell style={{ width: "13%" }}>{item?.site}</Cell>
          <Cell style={{ width: "13%" }}>{item.floor}</Cell>
          <Cell style={{ width: "13%" }}>{item.area}</Cell>
          <Cell style={{ width: "13%" }}>{item.camera}</Cell>
          <Cell style={{ width: "13%" }}>{item.roi}</Cell>
          <Cell style={{ width: "13%" }}>{item.condition}</Cell>
        </TableRow>
          ))}

        </TableBody>
      </Table>
    </div>
  );
}

export default BulkRuleTable;
